module.exports = __webpack_public_path__ + "static/media/RP-17.d77b1012.pdf";